<template>
  <div id="filterBox" class="filter-box collapse in">
    <div class="row">
      <div v-if="parsedConfig.includes('datepicker')" class="col-lg-4 col-md-6">
        <div class="form-group">
          <div class="input-group" style="z-index:900">
            <span class="input-group-addon">Zeitraum</span>
            <div class="form-control">
              <date-range-picker
                  ref="picker"
                  v-model="dateRange"
                  :max-date="today"
                  :ranges="ranges"
                  :locale-data="localeData"
                  @select="onDateRangeChanged"
                  @update="onDateRangeChanged"
                  :control-container-class="'daterange'"
              >
              </date-range-picker>
            </div>
          </div>
        </div>
      </div>
      <div v-if="parsedConfig.includes('companies')" class="col-lg-4 col-md-6">
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon">Unternehmen</span>
            <multiselect
                @input="triggerUpdate"
                :ref="`multiselectCompanies`"
                v-model="selectedCompanies"
                :options="companies"
                :loading="loading"
                placeholder="Bitte wählen Sie eine Option"
                :multiple="true"
                :hideSelected="true"
                track-by="id"
                label="value"
            >
              <template slot="option" slot-scope="props">{{props.option.value | translate}}</template>
              <template slot="tag" slot-scope="props">
                <span class="multiselect__tag">
                  <span>{{props.option.value | translate}}</span>
                  <i aria-hidden="true" tabindex="1" @keydown.enter.prevent="removeElement(props.option, 'multiselectCompanies')"  @mousedown.prevent="removeElement(props.option, 'multiselectCompanies')" class="multiselect__tag-icon"></i>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div v-if="parsedConfig.includes('salesChannels')" class="col-lg-4 col-md-6">
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon">Marktplatz</span>
            <multiselect
                :disabled="loading"
                :loading="loading"
                @input="triggerUpdate"
                :ref="`multiselectChannels`"
                v-model="selectedSalesChannels"
                :options="salesChannels"
                placeholder="Bitte wählen Sie eine Option"
                :multiple="true"
                :hideSelected="true"
                track-by="id"
                label="value"
            >
              <template slot="option" slot-scope="props">{{props.option.value | translate}}</template>
              <template slot="tag" slot-scope="props">
                <span class="multiselect__tag">
                  <span>{{props.option.value | translate}}</span>
                  <i aria-hidden="true" tabindex="1" @keydown.enter.prevent="removeElement(props.option, 'multiselectChannels')"  @mousedown.prevent="removeElement(props.option, 'multiselectChannels')" class="multiselect__tag-icon"></i>
                </span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>
      <div v-if="parsedConfig.includes('orderField')" class="col-lg-3 col-md-6">
        <select class="form-control" v-model="orderField">
          <option class="normal" :value="'order_id'">{{'order_id_ecommerce' | translate}}</option>
          <option class="normal" :value="'selling_price'">{{'selling_price_ecommerce' | translate}}</option>
          <option class="normal" :value="'order_return_id'">{{'order_return_id_ecommerce' | translate}}</option>
        </select>
      </div>
      <div v-if="parsedConfig.includes('categories')" class="col-xs-12">
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon">Hauptkategorie:</span>
            <div class="btn-group">
              <button data-toggle="tooltip" title="Damenschuhe" type="button" @click="toggleMain('damenschuhe')" :class="['btn btn-default',  mainCategory === 'damenschuhe' ? 'bg-success' : '']">{{'women' | translate}}</button>
              <button data-toggle="tooltip" title="Herrenschuhe" type="button" @click="toggleMain('herrenschuhe')" :class="['btn btn-default', mainCategory === 'herrenschuhe' ? 'bg-success' : '']">{{'men' | translate}}</button>
              <button data-toggle="tooltip" title="Kinderschuhe" type="button" @click="toggleMain('kinderschuhe')" :class="['btn btn-default', mainCategory === 'kinderschuhe' ? 'bg-success' : '']">{{'children' | translate}}</button>
              <button data-toggle="tooltip" title="Accessoires" type="button" @click="toggleMain('mode-accesoires')" :class="['btn btn-default', mainCategory === 'mode-accesoires' ? 'bg-success' : '']">{{'accesories' | translate}}</button>
              <button data-toggle="tooltip" title="Sportbedarf" type="button" @click="toggleMain('sportbedarf')" :class="['btn btn-default', mainCategory === 'sportbedarf' ? 'bg-success' : '']">{{'sport' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
        <!--<div class='row mt-10'>
          <div class="col-xs-3">
            <select class="form-control" :disabled="defaultCats || subcats.length === 0" v-model="selectedSubCat">
              <option v-if="!selectedSubCat" :value="false" class="normal">Wählen Sie eine sub Kategorie</option>
              <option v-for="cat in subcats" :value="cat" class="normal">{{formCatName(cat)}}</option>
            </select>
          </div>
          <div class="col-xs-3" v-if="selectedSubCat">
            <button type="button" @click="updateSubcats([mainCategory])" class="btn btn-warning"><i class="fa fa-trash-o mr-5"></i>Subkategorie löschen</button>
          </div>
        </div>-->
      <div v-if="parsedConfig.includes('brands')" class="col-xs-12">
        <div class="form-group">
          <div class="input-group mb-10">
            <span class="input-group-addon">Marken:</span>
            <input type="text" class="form-control" placeholder="z.B: adidas" ref="pepe" @keydown.enter.tab.stop.self="updateSelectedBrands($event)"/>
            <span class="input-group-btn">
            <button class="btn btn-primary" style="padding: 9px 12px" @click="() => {brands = []}"><i class="fa fa-undo mr-5"></i>Reset</button>
          </span>
          </div>
          <span v-for="tag in brands" class="multiselect__tag" style="margin-right: 2px"><span>{{tag}}</span> <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="brands.splice(brands.indexOf(tag), 1)"></i></span>
        </div>
      </div>
      <div v-if="parsedConfig.includes('products')" class="col-xs-12">
        <div class="form-group">
          <div class="input-group mb-10">
            <span class="input-group-addon">Artikel ID</span>
            <input type="text" class="form-control" placeholder="z.B: 186548" ref="productsSelector" @keydown.enter.tab.stop.self="updateSelectedProducts($event)"/>
            <span class="input-group-btn">
              <button class="btn btn-primary" style="padding: 9px 12px" @click="() => {products = []}"><i class="fa fa-undo mr-5"></i>Reset</button>
            </span>
          </div>
          <span v-for="tag in products" class="multiselect__tag" style="margin-right: 2px"><span>{{tag}}</span> <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="products.splice(products.indexOf(tag), 1)"></i></span>
        </div>
      </div>
      <div v-if="parsedConfig.includes('sort')" class="col-lg-3 col-md-6 col-xs-12 pull-left">
        <div class="form-group">
          <div class="input-group">
            <span class="input-group-addon">Sort:</span>
            <div class="btn-group">
              <button :class="{'btn btn-default': true, 'bg-success': sort === 'asc'}" @click="toggleSort('asc')"><i class="fa fa-arrow-up"></i></button>
              <button @click="toggleSort('desc')" :class="{'btn btn-default': true, 'bg-success': sort === 'desc'}"><i class="fa fa-arrow-down"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Api from '@/services/Api'
  import moment from "moment";
  import { bus } from "../main";
  import axios from 'axios';

  export default {
    props: ['config'],
    name: 'Filters',
    data () {
     return {
       loading: true,
       mainCategory: 'all',
       orderField: 'order_id',
       sort: 'desc',
       brands: [],
       subCats: [],
       products: [],
       defaultCats: true,
       selectedSubCat: false,
       dateRange: {
         startDate: moment().subtract('1', 'weeks').format('YYYY-MM-DD'),
         endDate: moment().format('YYYY-MM-DD')
       },
       selectedCompanies: [],
       selectedSalesChannels: [],
       companies: [],
       salesChannels: [],
       today: moment().format('YYYY-MM-DD'),
       localeData: {
         direction: 'ltr',
         format: 'dd.mm.yyyy',
         separator: ' - ',
         applyLabel: 'Anwenden',
         cancelLabel: 'Schließen',
         weekLabel: 'W',
         daysOfWeek: ['Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam', 'Son'],
         monthNames: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
         firstDay: 1
       },
     }
    },
    computed: {
      parsedConfig () {
        return this.config !== '' ? JSON.parse(this.config) : {}
      },
      filters () {
        return {
          companies: this.selectedCompanies,
          date: `${this.dateRange.startDate}#${this.dateRange.endDate}`,
          salesChannels: this.selectedSalesChannels,
          category: this.mainCategory,
          subcategories: this.subCats,
          orderField: this.orderField,
          sort: this.sort,
          brands: this.brands,
          products: this.products
        }
      },
      ranges () {
        let today = new Date()
        today.setHours(0, 0, 0, 0)
        let yesterday = new Date()
        yesterday.setDate(today.getDate() - 1)
        yesterday.setHours(0, 0, 0, 0);
        return {
          'Heute': [today, today],
          'Gestern': [yesterday, yesterday],
          'Dieser Monat': [new Date(today.getFullYear(), today.getMonth(), 1), today],
          'Letzter Monat': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
          'Vorjahr selber Zeitraum': [new Date(today.getFullYear() -1, 0, 1), new Date(today.getFullYear() -1, today.getMonth(), today.getDate())],
          'Vorjahr': [new Date(today.getFullYear() -1, 0, 1), new Date(today.getFullYear() -1, 11, 31)],
          'Dieses Jahr': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
          'Gesamt': [new Date(2017, 0, 1), today]
        }
      }
    },
    methods: {
      removeElement (element, ref) {
        this.$refs[ref].removeElement(element);
      },
      toggleSort (val) {
        this.sort = this.sort === val ? false : val
        this.triggerBus()
      },
      updateSubcats (val) {
        this.defaultCats = val.some(this.checkIfDefault)
        if (this.defaultCats) {
          this.subCats = []
          this.selectedSubCat = false
        }
        else {
          this.subCats = val
          //this.selectedSubCat = false
        }
        this.triggerBus()
      },
      toggleMain (cat) {
        this.mainCategory = this.mainCategory === cat ? 'all' : cat
        this.selectedSubCat = false
        this.triggerBus()

      },
      checkIfDefault (cat) {
        return cat === 'herrenschuhe' || cat === 'damenschuhe' || cat === 'kinderschuhe' || cat === 'mode-accesoires' || cat === 'sportbedarf'
      },
      formCatName (cat) {
        return cat.split('-').map(c =>
          this.$options.filters.capitalize(c)).join(' ')
      },
      arrayMove(arr, fromIndex, toIndex) {
        var element = arr[fromIndex]
        arr.splice(fromIndex, 1)
        arr.splice(toIndex, 0, element)
      },
      onDateRangeChanged (picker) {
        this.dateRange.startDate = moment(picker.startDate).format('YYYY-MM-DD')
        this.dateRange.endDate = moment(picker.endDate).format('YYYY-MM-DD')
        this.triggerBus()
      },
      updateSelectedBrands (val) {
        this.brands.push(val.target.value)
        this.$refs.pepe.value = ''
        this.triggerBus()
      },
      updateSelectedProducts(val) {
        this.products.push(val.target.value)
        this.$refs.productsSelector.value = ''
        this.triggerBus()
      },
      triggerUpdate () {
        if (this.selectedSalesChannels.length === 0 || this.selectedCompanies.length === 0) {
          this.$notify({
            group: 'foo',
            type: 'warn',
            title: 'Achtung!',
            text: 'Auswahl darf nicht leer sein'
          });
        } else {
          if (this.selectedSalesChannels[0].value === 'all' && this.selectedSalesChannels.length > 1) {
            this.selectedSalesChannels = this.selectedSalesChannels.filter(s => { return s.value !== 'all'})
          } else if (this.selectedSalesChannels.find(s => {return s.value === 'all'})) {
            this.selectedSalesChannels = [{id: 'all', value: 'all'}]
          }
          if (this.selectedCompanies[0].value === 'all' && this.selectedCompanies.length > 1) {
            this.selectedCompanies = this.selectedCompanies.filter(s => { return s.value !== 'all'})
          } else if (this.selectedCompanies.find(s => {return s.value === 'all'})) {
            this.selectedCompanies = [{id: 'all', value: 'all'}]
          } else if (this.selectedCompanies[0].value === 'ANWR Media GmbH' && this.selectedCompanies.length > 1) {
            this.selectedCompanies = this.selectedCompanies.filter(s => { return s.value !== 'ANWR Media GmbH'})
          } else if (this.selectedCompanies.find(s => {return s.value === 'ANWR Media GmbH'})) {
            let anwr = this.companies.find(c => { return c.value === 'ANWR Media GmbH'})
            this.selectedCompanies = [{id: anwr.id, value: 'ANWR Media GmbH'}]
          }
            this.$notify({group: 'foo', clean: true})
            this.triggerBus()
        }
      },
      triggerBus () {
        let tooltip = document.getElementById('chartjs-tooltip')
        if (tooltip) {
          tooltip.remove()
        }
        bus.$emit('updatedFilters', this.filters)
      }
    },
    mounted () {
      axios.all([Api().get(`/company`), Api().get('/salesChannels')])
        .then(axios.spread((...r) => {
          //this.companies = r[0].data.sort((a, b) => a.value.localeCompare(b.value))
          this.companies = r[0].data
          this.companies.unshift(this.companies[this.companies.length - 1])
          this.companies.splice(this.companies.length - 1, 1)
          let defaultCompany = this.companies.find(c => {return c.value === 'all'})
          if (defaultCompany) {
            this.selectedCompanies.push(this.companies[this.companies.indexOf(defaultCompany)])
          }
          else {
            this.selectedCompanies.push(this.companies[0])
          }
          this.salesChannels = r[1].data
          this.salesChannels.unshift(this.salesChannels[this.salesChannels.length - 1])
          this.salesChannels.splice(this.salesChannels.length - 1, 1)
          this.selectedSalesChannels.push(this.salesChannels[0])
          let tooltip = document.getElementById('chartjs-tooltip')
          if (tooltip) {
            tooltip.remove()
          }
          this.loading = false
          this.triggerBus()
        })).catch(errors => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
      })
    }
  }
</script>
<style>
 /* .vue-daterange-picker {
    display: inline !important;
  }
  .daterangepicker {
    position: absolute;
    color: inherit;
    background:#fff;
    width: 278px;
    padding: 4px;
    margin-top: 1px;
    top: 100px;
    left: 20px;
    !* Calendars *! }
  .daterangepicker:before, .daterangepicker:after {
    position: absolute;
    display: inline-block;
    border-bottom-color: rgba(0, 0, 0, 0.15);
    content: ''; }
  .daterangepicker:before {
    top: -7px;
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-bottom: 7px solid #fff;; }
  .daterangepicker:after {
    top: -6px;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #fff;
    border-left: 6px solid transparent; }
  .daterangepicker.opensleft:before {
    right: 9px; }
  .daterangepicker.opensleft:after {
    right: 10px; }
  .daterangepicker.openscenter:before {
    left: 0;
    right: 0;
    width: 0;
    margin-left: auto;
    margin-right: auto; }
  .daterangepicker.openscenter:after {
    left: 0;
    right: 0;
    width: 0;
    margin-left: auto;
    margin-right: auto; }
  .daterangepicker.opensright:before {
    left: 9px; }
  .daterangepicker.opensright:after {
    left: 10px; }
  .daterangepicker.dropup {
    margin-top: -5px; }
  .daterangepicker.dropup:before {
    top: initial;
    bottom: -7px;
    border-bottom: initial;
    border-top: 7px solid #282a31; }
  .daterangepicker.dropup:after {
    top: initial;
    bottom: -6px;
    border-bottom: initial;
    border-top: 6px solid #282a31; }
  .daterangepicker.dropdown-menu {
    max-width: none;
    z-index: 3001; }
  .daterangepicker.single .ranges, .daterangepicker.single .calendar {
    float: none; }
  .daterangepicker.show-calendar .calendar {
    display: block; }
  .daterangepicker .calendar {
    display: none;
    max-width: 270px;
    margin: 4px; }
  .daterangepicker .calendar.single .calendar-table {
    border: none; }
  .daterangepicker .calendar th, .daterangepicker .calendar td {
    white-space: nowrap;
    text-align: center;
    min-width: 32px; }
  .daterangepicker .calendar-table {
    border: 1px solid rgba(0,0,0,.15);
    padding: 4px;
    border-radius:0;
    background: #fff; }
  .daterangepicker table {
    width: 100%;
    margin: 0; }
  .daterangepicker td, .daterangepicker th {
    text-align: center;
    width: 20px;
    height: 20px;
    border-radius:0;
    border: 1px solid transparent;
    white-space: nowrap;
    cursor: pointer; }
  .daterangepicker td.available:hover, .daterangepicker th.available:hover {
    background:rgba(0,0,0,.15);}
  .daterangepicker td.week, .daterangepicker th.week {
    font-size: 80%;
    color: #ccc; }
  .daterangepicker td.off, .daterangepicker td.off.in-range, .daterangepicker td.off.start-date, .daterangepicker td.off.end-date {
    background-color: rgba(0,0,0,.025);
    border-color: transparent;
    color: #999; }
  .daterangepicker td.in-range {
    background-color:rgba(0,195,150,.5);
    border-color: transparent;
    color: currentColor;
    border-radius: 0; }
  .daterangepicker td.start-date {
    border-radius:0; }
  .daterangepicker td.end-date {
    border-radius:0; }
  .daterangepicker td.start-date.end-date {
    border-radius:0; }
  .daterangepicker td.active, .daterangepicker td.active:hover {
    background-color: #00C396;
    border-color: transparent;
    color: #fff; }
  .daterangepicker th.month {
    width: auto; }
  .daterangepicker td.disabled, .daterangepicker option.disabled {
    color: #999;
    cursor: not-allowed;
    text-decoration: line-through; }
  .daterangepicker select.monthselect, .daterangepicker select.yearselect {
    font-size: 12px;
    padding: 1px;
    height: auto;
    margin: 0;
    cursor: default; }
  .daterangepicker select.monthselect {
    margin-right: 2%;
    width: 56%; }
  .daterangepicker select.yearselect {
    width: 40%; }
  .daterangepicker select.hourselect, .daterangepicker select.minuteselect, .daterangepicker select.secondselect, .daterangepicker select.ampmselect {
    width: 50px;
    margin-bottom: 0;
    color:#282A31; }
  .daterangepicker .input-mini {
    border: 1px solid #ccc;
    border-radius:0;
    color: #555;
    height: 30px;
    line-height: 30px;
    display: block;
    vertical-align: middle;
    margin: 0 0 5px 0;
    padding: 0 6px 0 28px;
    width: 100%; }
  .daterangepicker .input-mini.active {
    border: 1px solid #00C396;
    border-radius:0; }
  .daterangepicker .daterangepicker_input {
    position: relative; }
  .daterangepicker .daterangepicker_input i {
    position: absolute;
    left: 8px;
    top: 8px; }
  .daterangepicker .calendar-time {
    text-align: center;
    margin: 5px auto;
    line-height: 30px;
    position: relative;
    padding-left: 28px; }
  .daterangepicker .calendar-time select.disabled {
    color: #ccc;
    cursor: not-allowed; }
  .ranges {
    font-size: 11px;
    float: none;
    margin: 4px;
    text-align: left; }
  .ranges ul {
    list-style: none;
    margin: 0 auto;
    padding: 0;
    width: 100%; }
  .ranges li {
    font-size: 13px;
    background: transparent;
    border: 1px solid rgba(0,0,0,.15);
    border-radius:0;
    color: #2a2a2a;
    padding: 3px 12px;
    margin-bottom: 8px;
    cursor: pointer; }
  .ranges li:hover {
    background: transparent;
    border: 1px solid #2a2a2a;
    color: #2a2a2a; }
  .ranges li.active {
    background: #00C396;
    border: 1px solid #00C396;
    color: #fff; }
  !*  Larger Screen Styling *!
  @media (min-width: 564px) {
    .daterangepicker {
      width: auto; }
    .daterangepicker .ranges ul {
      width: 160px; }
    .daterangepicker.single .ranges ul {
      width: 100%; }
    .daterangepicker.single .calendar.left {
      clear: none; }
    .daterangepicker.single .ranges, .daterangepicker.single .calendar {
      float: left; }
    .daterangepicker .calendar.left {
      clear: left;
      margin-right: 0; }
    .daterangepicker .calendar.left .calendar-table {
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0; }
    .daterangepicker .calendar.right {
      margin-left: 0; }
    .daterangepicker .calendar.right .calendar-table {
      border-left: none;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0; }
    .daterangepicker .left .daterangepicker_input {
      padding-right: 12px; }
    .daterangepicker .calendar.left .calendar-table {
      padding-right: 12px; }
    .daterangepicker .ranges, .daterangepicker .calendar {
      float: left; } }
  @media (min-width: 730px) {
    .daterangepicker .ranges {
      width: auto;
      float: left; }
    .daterangepicker .calendar.left {
      clear: none; } }*/
</style>
<style src="../../public/static/css/daterangepicker.css"></style>
